import { Component } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { NavigationEnd, Router } from "@angular/router";

import { ApiService } from "./api.service";
declare const BrandVars;
/* eslint-disable-next-line @typescript-eslint/ban-types */
declare const gtag: Function;

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrls: ["./app.component.scss"]
})
export class AppComponent {
	constructor(private title: Title, private api: ApiService, public router: Router) {
		api.LoadTokenIfPossible();
		this.title.setTitle(BrandVars.appName);
		// Kick off a GA update (if available) after route change
		this.router.events.subscribe(event => {
			if (BrandVars.analyticsId && event instanceof NavigationEnd) {
				gtag('config', BrandVars.analyticsId,
					{
						'page_path': event.urlAfterRedirects
					}
				);
			}
		});
	}
}
